<template>
<div class="topicSearchList">
	<ul>
		<li class="flex-container paddingh30 paddingv20 borderb topicEvent" v-for="item in data" v-if="fold?foldState?$index<showNum:true:true" @click="itemEvent(item)">
			<img :src="item.imageUrl||defaultImg.albumImage" onerror="this.src='{{defaultImg.albumImage}}'" class="input-radius">
			<div class="topicSearchList_title flex1">
				<dl class="paddingl10 frs-20">
					<dt class="flex-container">
						<span class="fs-15 text-fixed1" v-text="item.subTitle"></span>
					</dt>
					<dd class="text-fixed1 text-light margint10 fs-12" v-text="item.title"></dd>
				</dl>
			</div>
			<div class="iconCover badge badge-large badge-pill badge-reverse text-center" @click.stop="event_follow(item)" :class="{'badge-red badge-reverse':!item.hot,'badge-reverse':item.hot}" v-if="canbeControl">
				<i class="icon-check" v-if="item.hot"></i>
				<i class="icon-add" v-if="!item.hot"></i>
				<span v-text="!item.hot?'关注':'已关注'"></span>
			</div>
		</li>
		<li class="center flex-container marginb20 overflow-h paddingv10" style="color: #666;" v-if="fold?data.length>showNum:false" @click="foldList">
			<span v-text="fold?'展开显示全部':'收起展开'"></span><i class="icon" :class="'icon-'+(foldState?'unfold':'fold')"></i>
		</li>
	</ul>
</div>
</template>
<style lang="scss">
.topCoverlist input:placeholder{
    color: #666;
}
.topCoverlist input:-moz-placeholder{
    color: #666;
}
.topCoverlist input:-ms-input-placeholder{
    color:#666;
}
.topCoverlist input::-webkit-input-placeholder{
	color:#666;
}
.coverTitle:after{
	content:'';
	position:absolute;
	height:15px;
	width:2px;
	background: #ff6565;
	top:0.26666667rem;
	left:0.4rem;
}
.topicSearchList li img{
	width:1.3rem;
	height:1.3rem;
}
.topicSearchList li:last-child{
	border-bottom:0;
}
.topicSearchList .topicSearchList_title dt em{
	display:block;
}
</style>
<script>
import maple from 'maple';
import {defaultImg, errImg} from '../default.js';
import show from 'javascript/libs/tg/api/show.js';
export default {
	props: {
		data:{
			type:Array,
			default:[]
		}
		, defaultImg: {
			type: Object
			, default: defaultImg
		}
		, canbeControl:{
			type:Boolean,
			default:true
		}
		, fold: {
			type: Boolean
			, default: false
		}
		, showNum: {
			type: Number
			, default: 3
		}
	}
	, data(){
		return {
			foldState: this.fold
		}
	}
	, methods: {
		event_follow(item){
			item.count=item.count||0;
			if(item.count>5){
				return 
			}
		    if(item.hot){
		        show.followCancel({
		            data:{
		                labelId:item.id
		            },
		            success(){
		                item.hot=0;
		                item.count++;
		                maple.notice('取消关注成功');
		            }
		        })
		    }else{
		        show.followAdd({
		            data:{
		                labelId:item.id
		            },
		            success(){
		                item.hot=1;
		                item.count++;
		            }
		        })
		    }
		},
		itemEvent(item){
			_.has(item,'clickUrl')&&maple.pageIns.changePage(item.clickUrl)
		}
		, foldList(){
			this.foldState = !this.foldState;
		}
	}
}
</script>